import {
    IonCol,
    IonInput,
    IonItem,
    IonLabel,
    IonRow,
    isPlatform,
} from "@ionic/react";
import React, { useState } from "react";
import { calculateHeightInHands, calculateHeightInInches } from "../../utilities/horse/Height";
import RequiredInputIndicator from "../Forms/RequiredInputIndicator";
import { isWindows } from "../../utilities/platform/Platform";

interface _Props {
    isRequired?: boolean
    heightInInches?: number
    fraction: string
    onChange: (heightInInches: number, fraction: string) => void
}

const HorseHeightInput: React.FC<_Props> = ({isRequired, heightInInches, fraction, onChange}) => {
    const [currentHands, setCurrentHands] = useState(0.0);
    const [currentFraction, setCurrentFraction] = useState(fraction || "");
    const [currentInches, setCurrentInches] = useState(0.0);

    if (heightInInches != currentInches) {
        setCurrentInches(heightInInches || 0.0);
        setCurrentHands(heightInInches ? calculateHeightInHands(heightInInches) : 0.0)
    } 

    if (fraction !== currentFraction) {
        setCurrentFraction(fraction);
    }

    /**
     * The "hands" measurement is the standard unit to measure a horse in the U.S. 
     * We will keep it as the default unit in the user interface
     * However, the data should be stored in inches.
     * @param input number (Float)
     */
    const handleHandsInput = (handsInput: number) => {
        setCurrentHands(handsInput);
        const heightInInches = calculateHeightInInches(handsInput);
        setCurrentInches(heightInInches);
        onChange(heightInInches, currentFraction);
    }

    /**
     * The USEF and Welsh and Cob Society of America both allow fractions of an inch. 
     * Especially the WACSA want horse recordings to include fractions of an inch.
     * 1/4 of an inch is the standard fraction allowed, but we will allow this to be a general user input.
     * @param input string
     */
    const handleFractionInput = (fractionInput: string) => {
        setCurrentFraction(fractionInput);
        onChange(currentInches, fractionInput);
    }

    return (
        <>
            <IonRow>
                <IonCol size="6" className={`${isWindows() || isPlatform("desktop") ? "" : "pt-0"}`}>
                    <IonItem>
                        <IonLabel position="stacked" className="text-primary ion-text-wrap">Hands{isRequired && <RequiredInputIndicator />} (Ex: 15.3) </IonLabel>
                        <IonInput 
                            id="horseHeightInput"
                            type="number"
                            value={currentHands}
                            aria-required={true}
                            onIonChange={e => {
                                handleHandsInput(parseFloat(e.detail.value!))
                            }}
                        />
                    </IonItem>
                </IonCol>
                <IonCol size="6" className={`${isWindows() || isPlatform("desktop") ? "" : "pt-0"}`}>
                    <IonItem>
                        <IonLabel position="stacked" className="text-primary ion-text-wrap">Fraction (Ex: 1/4)</IonLabel>
                        <IonInput 
                            id="horseHeightFractionInput"
                            type="text"
                            value={currentFraction}
                            aria-required={false}
                            onIonChange={e => {
                                handleFractionInput(e.detail.value!)
                            }}
                        />
                    </IonItem>
                </IonCol>
            </IonRow>
        </>
    );
};

export default HorseHeightInput;